import {
	gridGutter,
	gridGutter1q3,
	gridGutterHalf,
	gridGutter1q6,
	fontSize18,
	fontSize16,
	fontSize14
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from '../../../../js/shared/new-theme';

const palette = theme.palette

export const loadingStyle = `
	display: flex;
	justify-content: center;
    flex-direction: column;
	padding: 64px 0;
	width: 100%;
	min-height: 500px;

	strong, span {
		text-align: center;
	}
	span {
		margin: 16px;
	}
`;

export const pageFidelityPrograms = `
	padding: ${gridGutter}px;
	@media (max-width: 576px) {
		padding: 0 ${gridGutter1q6}px ${gridGutter}px;
	}
`;

export const pageFidelityProgramsFlex = `
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const pageFidelityProgramsSearch = `
	@media (max-width: 576px) {
		display: none;
	}
	display: flex;
	flex-direction: row;
    justify-content: space-between;
	align-items: center;
	border-bottom: solid 1px ${palette.gray[400].value};
	padding: 16px 32px;

	& p {
		max-width: 330px;
		margin: 0;
		color: ${palette.gray[800].value};
	};
	& input {
		max-width: 230px
	};
`;

export const pageFidelityProgramsSearchInput = `
	@media (max-width: 767px) {
		display: none;
	}
`;

export const pageRegistrationData = (embeded = false) => `
	padding: ${embeded ? 0 : gridGutter}px;
	.box-title {
		margin-top: ${embeded ? gridGutterHalf : 0}px;
	}
	.box-bank-details {
		margin-top: ${embeded ? gridGutter * 1.5 : 0}px;

		select {
			font-weight: 500;
		}
	}
	.row {
		height: 100%;
		> div {
			height: 100%;
		}
	}
`;

export const pageOfferMiles = `
	width: 100%;
	.layout {
		display: flex;
		margin: ${gridGutter}px ${gridGutter}px ${gridGutter1q3 * 4}px ${gridGutter}px;

		&-offer-miles{
			flex: 4;
			padding-right: ${gridGutter}px;
		}

		&-card-ranking {
			flex: 3;
			margin-right: ${gridGutter}px;
		}
	}
`;

export const pagefineshedOffer = `
	display: flex;
	flex: 1;
	flex-direction: column;
	padding: ${gridGutterHalf * 3}px ${gridGutter}px;
	
	.layout {
		&--box {
			&-offer-registered {
				margin-bottom: ${gridGutter}px;
			}
			&-info-registered {
				margin-bottom: ${gridGutter * 2}px;
			}
			&-info-finished-offer{
				margin-bottom: ${gridGutter}px;
			}
			&-button {
				width: fit-content;
				margin: 0 auto;
				display: flex;
				font-size: ${fontSize18};

				a:hover {
					color: inherited;
				}
			}
		}


	.credit-card-input {
		position: relative;
	}
`;
export const pageUnsuccessOffer = `
	display: flex;
	width: 100%;

	.layout {
		&__box-unsuccess {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 48px;

			& strong {
				font-size: ${fontSize16};
				color: ${palette.gray[600].value};
			}

			& span {
				font-size: ${fontSize14};
				color: ${palette.gray[600].value};
				max-width: 480px;
				text-align: center;
				margin: 16px auto 48px;
			}

			a {
				width: fit-content;
				margin: 0 auto;
			}

		}
	}
}
`;
